var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53515 7.55882V3.06303H5.89367C6.24165 3.06303 6.57674 3.09104 6.89895 3.14706C7.22115 3.20308 7.50469 3.31513 7.74956 3.48319C7.99443 3.63725 8.18776 3.86134 8.32953 4.15546C8.48418 4.44958 8.56151 4.83473 8.56151 5.31092C8.56151 5.78712 8.48418 6.17227 8.32953 6.46639C8.18776 6.7605 7.99443 6.9916 7.74956 7.15966C7.50469 7.31373 7.22115 7.41877 6.89895 7.47479C6.57674 7.53081 6.24165 7.55882 5.89367 7.55882H3.53515ZM0.5 0.5V15.5H3.53515V10.1218H6.72496C7.58846 10.1218 8.32308 9.9888 8.92882 9.72269C9.53456 9.44258 10.0243 9.07843 10.3981 8.63025C10.7847 8.18207 11.0618 7.67087 11.2293 7.09664C11.4098 6.5084 11.5 5.91317 11.5 5.31092C11.5 4.69468 11.4098 4.09944 11.2293 3.52521C11.0618 2.95098 10.7847 2.43978 10.3981 1.9916C10.0243 1.54342 9.53456 1.18628 8.92882 0.920169C8.32308 0.640056 7.58846 0.5 6.72496 0.5H0.5Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingParking);
export default __webpack_public_path__ + "static/media/buildingParking.9998716120c3bcea2a0f13a5dcf75698.svg";
export { ForwardRef as ReactComponent };